import React, { useEffect, useState } from 'react';
import { getDashboardData } from '../../../../controllers/DashboardController';
import SuffererCard from '../card/SuffererCard';
import PanicCard from '../card/PanicCard';
import { FaMeh, FaFrown, FaSadTear, FaSadCry } from 'react-icons/fa';
import toast from 'react-hot-toast';
import Skeleton from '../../../../components/Skeleton';

const Statistic = ({ t }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await getDashboardData();
                setData(result || {});
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            };
        };
        
        fetchData();
    }, []);
    
    if (loading) {
        return (
            <div className='space-y-5'>
                <div className='flex flex-col xl:flex-row space-y-5 xl:space-y-0 xl:space-x-5'>
                    <Skeleton className='h-20 w-full rounded-lg' />
                    <Skeleton className='h-20 w-full rounded-lg' />
                    <Skeleton className='h-20 w-full rounded-lg' />
                    <Skeleton className='h-20 w-full rounded-lg' />
                </div>
                <div className='flex flex-col xl:flex-row space-y-5 xl:space-y-0 xl:space-x-5'>
                    <Skeleton className='h-28 w-full rounded-lg' />
                    <Skeleton className='h-28 w-full rounded-lg' />
                </div>
            </div>
        );
    };
    
    return (
        <div className='space-y-5'>
            {/* Sufferer Log */}
            <div className='flex flex-col xl:flex-row space-y-5 xl:space-y-0 xl:space-x-5'>
                <SuffererCard
                    icon={<FaMeh className='text-xl text-white' />}
                    gradientClass='bg-gradient-to-r from-successText to-successMessage'
                    title={t('statistic.totalSufferer')}
                    value={data?.total_sufferer || 0}
                />
                <SuffererCard
                    icon={<FaFrown className='text-xl text-white' />}
                    gradientClass='bg-gradient-to-r from-primary to-secondary'
                    title={t('common.classification.mildAnxiety')}
                    value={data?.total_screening.mild || 0}
                />
                <SuffererCard
                    icon={<FaSadTear className='text-xl text-white' />}
                    gradientClass='bg-gradient-to-r from-warningText to-warningMessage'
                    title={t('common.classification.moderateAnxiety')}
                    value={data?.total_screening.moderate || 0}
                />
                <SuffererCard
                    icon={<FaSadCry className='text-xl text-white' />}
                    gradientClass='bg-gradient-to-r from-errorText to-errorMessage'
                    title={t('common.classification.severeAnxiety')}
                    value={data?.total_screening.severe || 0}
                />
            </div>
            
            {/* Panic Log */}
            <div className='flex flex-col xl:flex-row space-y-5 xl:space-y-0 xl:space-x-5'>
                <PanicCard title={t('statistic.pendingPanicEvents')} value={data?.total_panic.status_pending || 0} />
                <PanicCard title={t('statistic.panicThisWeek')} value={data?.total_panic.this_week || 0} />
            </div>
        </div>
    );
};

export default Statistic;
